import { render, staticRenderFns } from "./AttendeesList.vue?vue&type=template&id=1a357265&"
import script from "./AttendeesList.vue?vue&type=script&lang=js&"
export * from "./AttendeesList.vue?vue&type=script&lang=js&"
import style0 from "./AttendeesList.vue?vue&type=style&index=0&id=1a357265&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports